module.exports = __webpack_public_path__ + "img/main-bg.28a6d4ac.webp";